
function LanguageModal(){
    $.fancybox.open({
        src: "#languageModalContainer",
        padding: 0, // Set padding to 0 to remove padding
        modal: false, // Make the modal block interact with the rest of the page
        customClass: "languageModal"
    });

}

jQuery(document).on("change",".goog-te-combo",function() {

    if(jQuery(this).val() == 'en'){ //value needs to be equal to default language, in my case nl
        location.reload(); 
    }else{
        $(".header__languages-language").html( $(".goog-te-combo").val().toUpperCase() );

        $.fancybox.close();
    }
});

$(document).ready(function() {

 $(".header__languages").click(function(){
        LanguageModal();
    });



 
    setInterval(function(){

        var gtc = $(".goog-te-combo").val();
        if (gtc != undefined && gtc != '') {
            $(".header__languages-language").html( $(".goog-te-combo").val().toUpperCase() );
        }
    }, 2000);
     
});
  

// Infinite scrolling
// let elem = document.querySelector('.container');
// infScroll = new InfiniteScroll(elem, {
//   path: '.pagination__next',
//   append: '.post',
//   status: '.page-load-status',
//   hideNav: '.pagination',
//   history: false, // Enable history state
//   //scrollRestore: true,
// });

document.addEventListener('DOMContentLoaded', function () {
    let pageNum = 2;
    const currentCollection = window.location.pathname.replace(/\/page\/\d+/, '');

    const infScroll = new InfiniteScroll('.container', {
      path() {
        return `${currentCollection}?page=${pageNum++}`;
      },
      append: '.grid__item',
      status: '.page-load-status',
      history: false,
      hideNav: '.pagination',
    });
  });